// Resolve a lucide-react icon by name string. Falls back to Sparkles.
import {
  Sparkles,
  HandHeart,
  Activity,
  MessageCircle,
  Waves,
  GraduationCap,
  BookOpen,
  Users,
  ShieldCheck,
  User,
  Star,
  Dumbbell,
  Spline,
  Footprints,
  PersonStanding,
  Bone,
  Flame,
  Brain,
  Baby,
  Accessibility,
  Stethoscope,
} from "lucide-react";

const REGISTRY = {
  Sparkles,
  HandHeart,
  Activity,
  MessageCircle,
  Waves,
  GraduationCap,
  BookOpen,
  Users,
  ShieldCheck,
  User,
  Star,
  Dumbbell,
  Spline,
  Footprints,
  PersonStanding,
  Bone,
  Flame,
  Brain,
  Baby,
  Accessibility,
  Stethoscope,
};

const Icon = ({ name, size = 22, className = "", strokeWidth = 1.8 }) => {
  const Cmp = REGISTRY[name] || Sparkles;
  return <Cmp size={size} strokeWidth={strokeWidth} className={className} />;
};

export default Icon;
